import React, { ReactElement } from 'react'

import { Color } from '../../../../enums/color'
import { Icon } from '../../../Icon'
import { getIconSize } from '../../utils/getIconSize'
import { InputSuffix, InputSuffixProps } from '../InputSuffix'

type SuccessIconProps = Omit<InputSuffixProps, 'children'>

export const SuccessIcon = ({ disabled, inputSize, ...rest }: SuccessIconProps): ReactElement => (
  <InputSuffix disabled={disabled} inputSize={inputSize} {...rest}>
    <Icon size={getIconSize(inputSize)} icon="circleCheck" color={disabled ? Color.Grey300 : Color.Green400} />
  </InputSuffix>
)
